import { PlusOutlined } from "@ant-design/icons";
import { Button, Collapse, ConfigProvider } from "antd";
import { ReactElement, useState } from "react";
import { useGetPermissionQuery } from "../../../../../store/api/permission.api";
import { ModalAddBank } from "../../../shared/ModalAddBank/ModalAddBank";
import { ModalChronology } from "../../../shared/ModalChronology/ModalChronology";
import { BankItemCollapseContent } from "./BankItemCollapseContent/BankItemCollapseContent";

import classes from "./AgentIndividualAward.module.css";

export function AgentIndivdualAward(): ReactElement {
  const [modalAddBankOpen, setModalAddBankOpen] = useState(false);
  const { data: permissionData } = useGetPermissionQuery(undefined);
  const banks = permissionData?.data.banks;

  const [modalChronologyOpen, setModalChronologyOpen] = useState(false);
  function handleShowChronology() {
    setModalChronologyOpen(true);
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            headerBg: "rgba(217, 229, 255, 0.4)",
            colorBorder: "rgba(60, 121, 255, 1)",
            headerPadding: "20px",
            contentPadding: "12px 20px 16px 20px",
          },
        },
      }}
    >
      <>
        <div className={classes.title}>Банки, участники площадки</div>
        <div className={classes.bankList}>
          <Collapse
            className={classes.bankItem}
            items={[
              {
                label: <span className={classes.bankName}>Камкомбанк</span>,
                children: (
                  <BankItemCollapseContent
                    onClickShowChronology={handleShowChronology}
                  />
                ),
              },
            ]}
            expandIconPosition="right"
          />

          <Collapse
            className={classes.bankItem}
            items={[
              {
                label: <span className={classes.bankName}>Росбанк</span>,
                children: (
                  <BankItemCollapseContent
                    onClickShowChronology={handleShowChronology}
                  />
                ),
              },
            ]}
            expandIconPosition="right"
          />
        </div>
        <Button
          onClick={() => {
            setModalAddBankOpen(true);
          }}
          className={classes.addBank}
          color="primary"
        >
          <PlusOutlined /> Добавить банк
        </Button>
      </>

      <>
        {banks && (
          <ModalAddBank
            banks={banks}
            open={modalAddBankOpen}
            cancelButtonProps={{ onClick: () => setModalAddBankOpen(false) }}
            onCancel={() => setModalAddBankOpen(false)}
          />
        )}
      </>

      <ModalChronology
        onCancel={() => {
          setModalChronologyOpen(false);
        }}
        open={modalChronologyOpen}
        bankName="Камкомбанк"
      />
    </ConfigProvider>
  );
}
